/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GetSettingsWorkplacesApiResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsWorkplaces: build.query<GetSettingsWorkplacesApiResponse, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/workplaces` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsWorkplacesApi };
export const { useGetSettingsWorkplacesQuery, useLazyGetSettingsWorkplacesQuery } = injectedRtkApi;
